export default [
  {
    id: 0,
    name: "Grandexpo",
    description: "WoolSafe Grand Expo World",
    image: "images/projects/grandexpo.png",
    tags: ["webgl", "javascript", "css"],
    liveview: "https://brianyoung-grandexpo.vercel.app/",
    alt: "WoolSafe Grand Expo portfolio project"
  },
  {
    id: 1,
    name: "NFT Gallery",
    description: "A collection and description of onigiriman's cute girl",
    image: "images/projects/fangirls.png",
    tags: ["webgl", "socketio", "javascript", "css"],
    liveview: "https://oncyber-k067n2m0f-brianyoung-0203.vercel.app/",
    alt: "A collection and description of onigiriman's cute girl portfolio project"
  },
  {
    id: 2,
    name: "Party Space",
    description: "Party Space for everyone",
    image: "images/projects/partspace.png",
    tags: ["webgl", "javascript", "html", "css"],
    liveview: "https://brianyoung-partyspace.vercel.app/",
    alt: "Party Space for everyone portfolio project",
  },
  {
    id: 3,
    name: "CryptoMines",
    description: "Mint NFTs, Explore Planets",
    image: "images/projects/cryptomines.app.png",
    tags: ["javascript", "solidity", "html"],
    liveview: "https://cryptomines.app/",
    alt: "Mint NFTs, Explore Planets portfolio project",
  },
  {
    id: 4,
    name: "Corporate Metaverse",
    description: "Corporate Metaverse Demo",
    image: "images/projects/corporate.png",
    tags: ["webgl", "javascript", "backend"],
    liveview: "https://brianyoung-metaverse.vercel.app/",
    alt: "Corporate Metaverse Demo portfolio project",
  },
  {
    id: 5,
    name: "BUSD Fomominer",
    description: "16% Fixed Daily Profit",
    image: "images/projects/busd.fomominer.com.png",
    tags: ["webgl", "javascript", "html", "css"],
    liveview: "https://busd.fomominer.com/",
    alt: "16% Fixed Daily Profit portfolio project",
  },
  {
    id: 6,
    name: "Zeustaking",
    description: "Fixed 20% Daily Rewards",
    image: "images/projects/zeustaking.finance.png",
    tags: ["javascript", "solidity"],
    liveview: "https://zeustaking-app.vercel.app/",
    alt: "Fixed 20% Daily Rewards portfolio project",
  },
  {
    id: 7,
    name: "Everburn Defi",
    description: "Hyper-Deflationary reflection token, rapidly burning supply on every buy and sale",
    image: "images/projects/everburns.io.png",
    tags: ["javascript", "solidity"],
    liveview: "https://everburn.io/",
    alt: "Hyper-Deflationary reflection token, rapidly burning supply on every buy and sale portfolio project",
  },
  {
    id: 8,
    name: "Cartoon Child",
    description: "Cartoon Child NFT Collection",
    image: "images/projects/nft_collection.png",
    tags: ["photoshop", "javascript"],
    alt: "Cartoon Child NFT Collection portfolio project",
  }
];
